module.exports = __webpack_public_path__ + "img/cadd-modelling.5f5e6ca2.jpg";